
export const GET_USED_TOWNS = "GET_USED_TOWNS"
export const SAVE_USED_TOWNS = "SAVE_USED_TOWNS"
export const GET_PUBLIC_PROPERTIES = "GET_PUBLIC_PROPERTIES"
export const SAVE_PUBLIC_PROPERTIES = "SAVE_PUBLIC_PROPERTIES"
export const GET_PRICE_RANGES = "GET_PRICE_RANGES"
export const GET_PUBLIC_PROPERTY = "GET_PUBLIC_PROPERTY"
export const APPLY_FILTERS = "APPLY_FILTERS"
export const API_URL = `http://${window.location.hostname}:4000`
